import { Component, OnInit, Inject, Injectable, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ConfirmationModalData } from '../../interfaces/confirmation-modal-data';
import { CONFIRMATION_MODAL_DATA } from '../../tokens/confirmation-data.token';
import { ConfirmationModalOverlayRef } from '../../classes/confirmation-modal.ref';
import { ConfirmationModalConfig, ConfirmationModalService } from '../../services/confirmation-modal.service';
import { Observable, filter, of, switchMap } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  modalSetting!: ConfirmationModalData;
  constructor(
    public dialogRef: ConfirmationModalOverlayRef,
    @Inject(CONFIRMATION_MODAL_DATA) public data: any,
    private sanitizer: DomSanitizer,
    
  ) { }
  // @ViewChild('openModal', { static: false }) openModal: ElementRef;

  // ngAfterViewInit() {
  //   // Focus the confirm button when modal is opened
  //   setTimeout(() => {
  //     if (this.openModal?.nativeElement) {
  //       this.openModal.nativeElement?.focus();
  //     }
  //   }, 0);
  // }
  
  // Optional: Prevent Enter from triggering unintended actions
  // @HostListener('document:keydown.enter', ['$event'])
  // handleEnterKey(event: KeyboardEvent) {
  //   // Only allow Enter to trigger if focus is on confirm button
  //   if (document.activeElement !== this.openModal?.nativeElement) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //   }
  // }
  
  sanitizedSubtext(data: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.data.subtext);
  }

  ngOnInit() {
    //console.log(this.data);
    this.modalSetting = this.data;
  }


  public modalAction($event: any) {
    this.dialogRef.events.next({
      type: 'close',
      data: this.data
    });
  }

  public closeModal($event: any) {
    this.dialogRef.events.next({
      type: 'btnClose',
      data: this.data
    });
  }

  public confirmModal($event: any) {
    this.dialogRef.events.next({
      type: 'btnConfirm',
      data: this.data
    });
  }

  public cancelModal($event: any) {
    this.dialogRef.events.next({
      type: 'btnCancel',
      data: this.data
    });
  }
}



@Injectable()

export class ConfirmationMdlService {
  private confirmationRef!: ConfirmationModalOverlayRef;
  constructor(private _ConfirmationModalService: ConfirmationModalService) { }

  init(_ConfirmationModalConfig: ConfirmationModalConfig = {}): Observable<any> {

    this.confirmationRef =
      this._ConfirmationModalService.open<ConfirmationComponent>(
        ConfirmationComponent,
        _ConfirmationModalConfig
      );
    return this.confirmationRef.events.pipe(
      filter((event) => {
        return !!event
      }),
      switchMap((v) => {
        v['initRef'] = this.confirmationRef;
        return of(v)
        // return new Promise<void>((resolve, reject) => {
        //   resolve(v)
        // })
      })
    )

  }

}